import { INDICATION_TYPES } from 'taboola-ultimate-ui';
import { useCurrentCampaignTargetingByType } from 'modules/campaigns/modules/common-campaign-form/components/SiteTargeting/utils/useCurrentCampaignTargetingByType';
import { isSupplyTargetingRestrictionEnforced } from 'modules/campaigns/modules/common-campaign-form/components/SupplyTargeting/utils/isSupplyTargetingRestrictionEnforced';
import { CREATIVE_TYPES } from 'modules/campaigns/modules/creative-display/config/displayTypes';
import { CustomValidationError } from 'modules/errors/CustomValidationError';
import { useFormFieldValue } from 'modules/taboola-common-frontend-modules/formData';
import { useFormValidatedValue } from 'modules/taboola-common-frontend-modules/validations';
import { SUPPLY_TARGETING_TYPES } from '../const';
import { useAPISupplyTargetingRestrictions } from './useAPISupplyTargetingRestrictions';

const validations = [
    {
        validationFn: (supplyTargeting, _, dependencies) =>
            isSupplyTargetingRestrictionEnforced({ supplyTargeting, ...dependencies }),
        messageId: 'campaign.editor.targeting.supply.unsupported.targeting.default.message',
        defaultMessage:
            'Please note: This campaign will not serve on the selected environment because one or more of the following are' +
            ' applied: DMA targeting, Region targeting, City targeting, Zip Code targeting, Connection Type targeting,' +
            ' Topic Segments targeting, Audience or 3rd Party Tags.',
        severity: INDICATION_TYPES.ERROR,
    },
    {
        validationFn: (supplyTargeting, _, { eligibilityType }) => {
            if (
                eligibilityType === CREATIVE_TYPES.DISPLAY &&
                (supplyTargeting === SUPPLY_TARGETING_TYPES.APPLE_NEWS ||
                    supplyTargeting === SUPPLY_TARGETING_TYPES.MAIL)
            ) {
                throw new CustomValidationError({
                    messageCode: `campaign.editor.targeting.supply.display.item.${supplyTargeting}`,
                    message: '{supplyTargeting} cannot support Display',
                });
            }
            return true;
        },
        messageId: `campaign.editor.targeting.supply.display.item`,
        defaultMessage: 'Mail cannot support Display',
    },
];

export const useValidateSupplyTargetingFormField = () => {
    const currentCampaignTargetingByType = useCurrentCampaignTargetingByType();
    const { supplyTargetingResource, isSupplyPermitted, isTaboolaDefaultValue, isPermitted } =
        useAPISupplyTargetingRestrictions();
    const { value: eligibilityType } = useFormFieldValue({ field: 'eligibilityType' });

    const formFieldProps = useFormValidatedValue({
        field: 'campaignTargeting.supplyTargeting',
        validations,
        validationDependencies: {
            currentCampaignTargetingByType,
            supplyTargetingResource,
            eligibilityType,
        },
        formFieldDependencies: {
            isSupplyPermitted,
            isTaboolaDefaultValue,
            isPermitted,
        },
    });

    return formFieldProps;
};
